// import { CardContent,/*, Input, Typography */} from "@material-ui/core";
// import Card from '@material-ui/core/Card';
import { InputProps } from "@material-ui/core/Input";
import React, { ChangeEvent } from "react";
// import { strIsNullOrEmpty } from "../../utils/string";
import './block-quote.css';
import Chip from "@material-ui/core/Chip";
import { QuotedSubjectModel } from "../../model/autogen/QuotedSubjectModel";
import { findPeopleHelper, resolvePeopleHelper } from "../forms/form-state-helper";
import { IAuthContextProps, withAuthContext } from "../with-auth-context";
import { PersonModel } from "../../model/autogen/PersonModel";
import { PersonInfo } from "../../model/autogen/PersonInfo";
import { DisplayQuote } from "./display-quote";
import { EditQuote } from "./edit-quote";
import { QuoteModel } from "../../model/autogen/QuoteModel";
import * as moment from "moment";
import { isArrayNullOrEmpty } from "../../utils/array";
import { FilesRequestFactory } from "../../model/autogen/FilesController";
import { ISnackbarContextProps, withSnackbar } from "../with-snackbar";
import { TagModel } from "../../model/autogen/TagModel";
import { findTagsHelper, resolveTagsHelper } from "../forms/form-state-helper";



export interface IBlockQuote {
    quote: QuoteModel,
    //editable?: boolean;0
    style?: React.CSSProperties,
    className?: string,
    customDecoration?: JSX.Element,
    subjects?: QuotedSubjectModel[] | undefined;
    author?: PersonModel;
    cannotSave?: () => void;
    edit?: boolean;
    expanded?: boolean;
    onDateChange?: (date: moment.Moment) => void;
}

export interface IBlockQuoteState {
    quote: QuoteModel;
    isUploadingFiles: boolean;
}

export type IEditableBlockQuoteCoreProps = IBlockQuote & InputProps & {
    onPeopleChanged?: (subjects: PersonModel[]) => void;
}

type IEditableBlockQuoteProps = IEditableBlockQuoteCoreProps & IAuthContextProps & ISnackbarContextProps;

export const createChip = (person: PersonModel | PersonInfo) => {
    const path = `/person/${person.id}`;
    const name = `${person.firstName} ${person.lastName}`
    const goToPerson = (e: any) => {
        return window.location.pathname = path;
    }
    return <Chip key={person.id} label={name} onClick={goToPerson} clickable />
}

export const createChipArray = (people: QuotedSubjectModel[] | undefined) => {
    return (
        <div style={{ marginBottom: "10px" }}>
            {people !== undefined ? people.map((per: QuotedSubjectModel) => {
                return <span key={per.id} style={{ marginRight: "10px" }}>{createChip(per.subject)}</span>
            }) : ""}
        </div>
    )
}

class BlockQuoteComponent extends React.Component<IEditableBlockQuoteProps, IBlockQuoteState> {

    constructor(props: IEditableBlockQuoteProps) {
        super(props);
        this.state = {
            quote: props.quote,
            isUploadingFiles: false
        }
    }

    private onQuoteChange = (e: ChangeEvent<HTMLInputElement>) => {
        var changedField = e.target.name
        var quote = this.state.quote
        quote[`${changedField}`] = e.target.value
        this.setState({quote: quote})
        this.props.cannotSave != undefined ? this.props.cannotSave() : null
    }
    private onDateChange = (date: moment.Moment) => {
        var quote = this.state.quote
        quote.dateOfQuote = date.toDate();
        this.setState({ quote: quote });
    }
    private onFetchPeople = (query: string) => {
        return findPeopleHelper(this.props.callApi, query)
    }
    private onResolvePeople = (peopleIds: number[]) => {
        return resolvePeopleHelper(this.props.callApi, peopleIds);
    }
    private onPeopleChanged = (subjects: PersonModel[]) => {
        if (this.props.onPeopleChanged) {
            this.props.onPeopleChanged(subjects);
        }
    }
    private onFileDrop = async (acceptedFiles: File[], rejectedFiles: File[]) => {
        const { callApi } = this.props;
        try {
            if (!isArrayNullOrEmpty(acceptedFiles)) {
                this.setState({ isUploadingFiles: true});
                const result = await callApi(f => FilesRequestFactory.upload(f, { file: acceptedFiles[0] }))
                const quote = this.state.quote;
                quote.assignFiles = [...(quote.assignFiles || []), result]
                this.props.cannotSave ? this.props.cannotSave() : null ;
                this.setState({ isUploadingFiles: false, quote});
            }
        } catch (e) {
            this.props.showSnackbarMessage(`Failed to upload file: ${e}`);
            this.setState({ isUploadingFiles: false });
        }
    }
    private onTagsChanged = (tags: TagModel[]) => {
        var quote = this.state.quote
        quote.createTags = tags
        this.setState({ quote: quote });
    }

    private onSearchTags = (query: string) => {
        return findTagsHelper(this.props.callApi, query, false);
    }

    private onResolveTags = (tags: string[]) => {
        return resolveTagsHelper(this.props.callApi, tags);
    }

    public render(): JSX.Element {
        return <>
            <div style={{ padding: '10px'}}>
                    <div>
                        {!this.props.edit && <DisplayQuote quote={this.state.quote} author={this.props.author} key={this.state.quote.id}/>}
                        {this.props.edit && <EditQuote expanded={this.props.expanded} customDecoration={this.props.customDecoration} quote={this.state.quote} onQuoteChange={this.onQuoteChange} onDateChange={this.onDateChange} onFetchSubjects={this.onFetchPeople} onSubjectsChanged={this.onPeopleChanged} onResolveSubjects={this.onResolvePeople} onFileDrop={this.onFileDrop} isUploadingFiles={this.state.isUploadingFiles} onTagsChanged={this.onTagsChanged} onSearchTags={this.onSearchTags} onResolveTags={this.onResolveTags} key={this.state.quote.id}/>}
                    </div>
            </div>
        </>
    }
}

export const BlockQuote = withSnackbar(withAuthContext(BlockQuoteComponent)) as React.ComponentType<IEditableBlockQuoteCoreProps>;

/*
export interface IEditableBlockQuote {

}

export const EditableBlockQuote = (props: IBlockQuote) => {
    return <div>
        <BlockQuote editable={true} {...props}  />
    </div>
}*/


// WEBPACK FOOTER //
// ./src/components/material/block-quote.tsx